export default "__VITE_ASSET__CKa6YtBp__ 600w";